<template>
  <el-container>
    <div class="welcome-page">
      <router-view></router-view>
    </div>
  </el-container>
</template>

<script>
// import LoginInput from '../components/Login/LoginInput'

export default {
  name: 'welcome-screen',
  components: {
    // LoginInput
  },
}
</script>

<style lang="scss">
.el-container.is-vertical {
  padding: 0%;
}
.welcome {
  &-page {
    height: 100%;
    width: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    overflow: visible;
    position: relative;
    .bg-ellips {
      position: absolute;
      width: 2101px;
      height: 1204px;
      top: 50%;
      z-index: 0;
      border-radius: 50%;
      opacity: 0.3;
    }
  }
  &-container {
    @extend .w6, .pa3;
    z-index: 9;
  }

  &-image {
    @extend .w5, .mb4;
    cursor: pointer;
  }
}
</style>
